import cl from 'classnames';
import * as React from 'react';
import { Transforms } from 'slate';
import { ReactEditor, useSlateStatic } from 'slate-react';
import styled from 'styled-components';

import { ButtonEyeShowHide } from '../../ButtonEyeShowHide';
import {
  defaultIsEmptyText,
  EditorPlaceHolder,
} from '../../Paragraph/components/EditorPlaceHolder';
import { BaseOutlineStatementProps } from '../OutlineStatementPlugin.types';

const Main = styled.div`
  display: grid;
  grid-template-columns: 1fr max-content;
  gap: 24px;
  align-items: center;
`;

interface OutlineStatementProps extends BaseOutlineStatementProps {}

export const OutlineStatement = (props: OutlineStatementProps) => {
  const { attributes, children, element, isReadOnly } = props;
  const editor = useSlateStatic();
  return (
    <EditorPlaceHolder
      isEmptyText={() => {
        return defaultIsEmptyText(element);
      }}
      placeholderClassName="h2-placeholder"
      isReadOnly={isReadOnly}
      placeHolderText="Insert Statement here..."
    >
      <Main {...attributes} className={cl('outline-statement-element', element.id)}>
        <div className="h2">{children}</div>

        {!isReadOnly && (
          <ButtonEyeShowHide
            isHide={element.isHide as boolean}
            onMouseDown={(e) => {
              e.preventDefault();
              const path = ReactEditor.findPath(editor as any, element);
              Transforms.setNodes(editor, { isHide: !element.isHide }, { at: path });
            }}
          />
        )}
      </Main>
    </EditorPlaceHolder>
  );
};
